export const LANGUAGE_DE = "de"
export const LANGUAGE_EN = "en"

export const SCENE_MODE = "scene"

export const INTRO_START = "start"
export const INTRO_IMPRINT = "imprint"
export const INTRO_PRIVACY_POLICY = "privacyPolicy"

export const EASINGS = {
  outSine: [0.61, 1, 0.88, 1],
  inSine: [0.12, 0, 0.39, 0]
}
